// extracted by mini-css-extract-plugin
export var closeButton = "_i0-1";
export var closeX = "_i0-3";
export var container = "_i0-0";
export var image = "_i0-2";